import Seo from './Seo'

/* React */
import { useEffect } from 'react'

/* Redux */
import Redux from './Wunschliste.Redux'

/* Material */
import Container from '@mui/material/Container'
import Typo from '@mui/material/Typography'
import useStyles from './styles'

/* Material-Icons */
import FavoriteIcon from '@mui/icons-material/Favorite'

/* Types */
import { isFilterProductsResponse } from 'src/shared/frontendTypes/productsFilter'

/* Functions */
import { post } from 'src/functions/fetch'

/* Components */
import Lehr from './Lehr'
import Inhalt from './Components/Inhalt/Inhalt'
import StaticBreadcrumbs from 'src/components/Breadcrumbs/StaticBreadcrumbs'

/* Options */
import config from 'src/config'

const breadcrumb = [
  { title: 'Wunschliste' },
]

const Wunschliste = () => {
  const classes = useStyles()
  const { items, dispatchProducts } = Redux()

  /* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  // Die aktuellen Produkt-Daten laden

  const loadProducts = async (signal:AbortSignal) => {
    const keys = Object.keys(items)

    const data = await post({
      url:'products', 
      body:{
        size: keys.length,
        keys,
        ...config.shop,
      },
      signal,
    })

    if (!isFilterProductsResponse(data)) { console.error('Konnte Wunschlisten-Produkte nicht laden!'); return }
    
    dispatchProducts(data.filterProducts.products)
  }

  /* ------------------------------------------------------ */

  useEffect(() => {
    const controller = new AbortController(), signal = controller.signal
    if (Object.values(items).length > 0)
      loadProducts(signal)

    return () => controller.abort()
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [items]
  )
  /* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

  if (Object.keys(items).length === 0) return <Lehr />
  
  return <Container maxWidth='lg' className={classes.container}>

    <Seo />

    <StaticBreadcrumbs items={breadcrumb} />

    <Typo component='h1' variant='h4' color='inherit' gutterBottom>
      <FavoriteIcon/>
      {' '} Meine Wunschliste {' '}
      <FavoriteIcon/>
    </Typo>

    <div className={classes.wunschliste}>
      <Inhalt />
    </div>

  </Container>
}

export default Wunschliste
